import { EVENT_CODE } from '@constants'
import { ActionRow } from '@types'

export const checkAvailabilityEventInActions = (
  actions: ActionRow[] | undefined,
  event: EVENT_CODE
) => {
  return actions && actions.some(action => action.eventCode === event)
}
